import React, { useState, useEffect, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  Select, Divider, Drawer,
  notification,
  Tooltip,
} from 'antd';
import SellerActions from '@Actions/sellerActions';
import Helpers from '@Apis/helpers';
import H3Text from '@Uilib/h3Text';
import H3Image from '@Uilib/h3Image';
import closeIcon from '@Images/icons/icon-close-blue.png';
import VendorForm from '@Components/Common/VendorForm';

import './style.scss';
import useDebouncedEffect from '../../../hooks/useDebouncedEffect';
import PRZSelect from '../UI/PRZSelect';

const { Option } = Select;

const SelectSellerV2 = (props) => {
  const {
    sellers, onChange, selectedSeller, disabled, showError, title, hideTitle, containerClass, inputClassName, labelClassName,
    getSellers, user, showAddVendor, getPopupContainer, customStyle, notRequired, dropdownAlign, tenantId, showAllSeller,
    mapSellerId, marketplace, isSubcontractor, transporter, getSellersLoading, placeholder, isMarketplaceSeller, isMultiple, dontIncludesThisSellerIdsInList,
  } = props;

  const [showNewVendorModal, setShowNewVendorModal] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [searchValue, setSearchValue] = useState('');

  useEffect(() => {
    if ((tenantId || user?.tenant_info?.tenant_id)) {
      getSellers('', tenantId || user?.tenant_info?.tenant_id, 1, 1000, '', () => { }, true, isSubcontractor, '', '', dontIncludesThisSellerIdsInList);
    }
  }, [tenantId, user, isSubcontractor, dontIncludesThisSellerIdsInList]);

  useDebouncedEffect(() => {
    if (searchValue || searchValue === '') {
      getSellers(
        searchValue,
        tenantId || user?.tenant_info?.tenant_id,
        1,
        1000,
        '',
        () => { },
        true,
        isSubcontractor,
        '',
        isMarketplaceSeller,
        '',
        dontIncludesThisSellerIdsInList,
      );
    }
  }, 300, [searchValue]);

  const permissionForCreateVendor = Helpers.getPermission(
    Helpers.permissionEntities.VENDORS,
    Helpers.permissionTypes.CREATE,
    user,
  );

  const handleVendorModalClose = () => {
    setShowNewVendorModal(false);
  };

  const handleVendorAdd = () => {
    if (permissionForCreateVendor) {
      setShowNewVendorModal(true);
    } else {
      notification.error({
        message: 'You do not have permission to create a new vendor.',
        duration: 4,
        placement: 'top',
      });
    }
  };

  return (
    <div className={`${containerClass} select-vendor__wrapper` || 'orgInputContainer select-vendor__wrapper'}>
      <Drawer
        open={showNewVendorModal}
        onClose={handleVendorModalClose}
        width="720px"
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '680px' }}>
            <H3Text text="Add New Vendor" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={handleVendorModalClose} />
          </div>
        </div>
        <VendorForm
          callback={(createdSeller) => {
            getSellers('', tenantId || user?.tenant_info?.tenant_id, 1, 1000, '', (newSellers) => {
              onChange(newSellers?.sellers.filter((seller) => seller?.seller_id === createdSeller.seller_id)[0]);
              setShowNewVendorModal(false);
            }, true, isSubcontractor, '', isMarketplaceSeller);
          }}
          subcontractorForm
          isMarketplaceSellerProp={isMarketplaceSeller}
        />
      </Drawer>
      {!hideTitle ? (
        <div className={labelClassName || 'orgFormLabel'}>
          {title || 'Select Vendor'}
          {!notRequired && <span style={{ color: 'red' }}>{'  *'}</span>}
        </div>
      ) : <label />}
        <PRZSelect
          onDropdownVisibleChange={(open) => setDropdownOpen(open)}
          value={selectedSeller}
          filterOption={false}
          getPopupContainer={getPopupContainer ? (triggerNode) => triggerNode.parentNode : false}
          placeholder={placeholder || (transporter ? 'Select Transporter..' : 'Select vendor..')}
          disabled={disabled}
          loading={getSellersLoading}
          maxTagCount="responsive"
          mode={isMultiple ? 'multiple' : ''}
          onChange={(value) => {
            if (isMultiple) {
              onChange(value);
            } else {
              onChange(
                sellers?.sellers?.filter((seller) => ((mapSellerId ? seller?.seller_id : seller?.tenant_seller_id) === value))[0],
              );
              setSearchValue('');
            }
          }}
          showSearch
          onSearch={(value) => setSearchValue(value)}
          dropdownRender={
            showAddVendor ? (menu) => (
              <React.Fragment>
                {menu}
                <Divider style={{ margin: '0px' }} />
                <div
                  className="add__vendor"
                  onClick={handleVendorAdd}
                >
                  + Add Vendor
                </div>
              </React.Fragment>
            ) : false
          }
          allowClear
          showError={showError}
          errorName={transporter ? 'transporter' : 'vendor'}
          errorClassName="input-error"
          className={inputClassName}
        >
          {showAllSeller && <Option key="" value="">All Vendors</Option>}
          {sellers && sellers.sellers && sellers.sellers
            ?.filter((seller) => (marketplace ? seller?.seller_info?.is_marketplace_seller : !seller?.seller_info?.is_marketplace_seller))
            ?.filter((seller) => (transporter ? seller?.seller_info?.is_transporter : true))
            ?.filter((seller) => seller?.is_active)
            ?.map((item) => (
              <Option key={mapSellerId ? item.seller_id : item.tenant_seller_id} value={mapSellerId ? item.seller_id : item.tenant_seller_id}>
                <Tooltip
                  title={
                    <div>{item?.seller_info?.seller_name || 'N/A'}</div>
                  }
                >
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    <div>
                      <span className="seller-name">
                        {item?.seller_info?.internal_slr_code || ''}
                      </span>
                      <span className="separator"> - </span>
                      <span className="customer-name">
                        {item?.seller_info?.seller_name}
                      </span>
                      {item?.seller_info?.office_address_details && (
                        <span className="city-info">
                          (
                          {item?.seller_info?.office_address_details?.city}
                          )
                        </span>
                      )}
                    </div>
                  </div>
                </Tooltip>
              </Option>
            ))}
        </PRZSelect>
    </div>
  );
};

const mapStateToProps = ({ SellerReducers, UserReducers }) => ({
  getSellersLoading: SellerReducers.getSellersLoading,
  sellers: SellerReducers.sellers,
  user: UserReducers.user,
});

const mapDispatchToProps = (dispatch) => ({
  getSellers: (keyword, tenantId, page, limit, sellerId, callback, isActive, isSubcontractor, sellerType, isMarketplaceSeller, selectedSellerIds, excludeSellerIds) => dispatch(
    SellerActions.getSellers(keyword, tenantId, page, limit, sellerId, callback, isActive, isSubcontractor, sellerType, isMarketplaceSeller, selectedSellerIds, excludeSellerIds),
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SelectSellerV2));